import React, { useEffect } from "react";

export function useAutoResizeTextarea(
    ref: React.RefObject<HTMLTextAreaElement>,
    deps: unknown[] = []
) {
    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const resize = () => {
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight - 12}px`;
        };

        resize();
        window.addEventListener("resize", resize);
        return () => window.removeEventListener("resize", resize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}